const fr: Record<string, string> = {
  'dashboard.title': 'Tableau de bord',
  'dashboard.tabs.tasks': 'Tâches',
  'dashboard.tabs.tribes': 'Tribus',
  'dashboard.tabs.bookmarks': 'Favoris',
  'dashboard.tabs.planning': 'Planning',
  'dashboard.tabs.projects': 'Projets',
  'dashboard.tabs.taskInstances': 'Tâches',
  'dashboard.tabs.eventInstances': 'Événements',

  'dashboard.planning.noEvents': 'Aucun événement ce jour.',
  'dashboard.planning.noTasks': 'Aucune tâche à rendre aujourd\'hui.',
  'dashboard.planning.tasksDue': 'Tâches à rendre',

  'tabConfig.configure': 'Configurer les onglets',
  'tabConfig.finishConfigure': 'Terminer',
  'tabConfig.tab': 'Onglet',
  'tabConfig.visible': 'Visible',
  'tabConfig.default': 'Par défaut',
  'tabConfig.order': 'Ordre',
  'tabConfig.moveUp': 'Monter',
  'tabConfig.moveDown': 'Descendre',
  'tabConfig.toggleVisibility': 'Basculer la visibilité',
  'tabConfig.setDefault': 'Définir comme onglet par défaut',
  'tabConfig.icon': 'Icône',
  'tabConfig.color': 'Couleur',
  'tabConfig.name': 'Nom',
  'tabConfig.hideName': 'Masquer le nom (icône seule)',
  'tabConfig.showName': 'Afficher le nom',
  'tabConfig.setIconFirst': 'Choisissez d\'abord une icône',

  'features.addFeature': 'Ajouter une fonctionnalité',
  'features.feature': 'Fonctionnalité',
  'features.remove': 'Supprimer',
  'features.featureType': 'Type de fonctionnalité',
  'features.selectType': 'Sélectionner un type...',
  'features.featureName': 'Nom',
  'features.featureNamePlaceholder': 'ex. Backlog du sprint',
  'features.featureIcon': 'Icône (facultative si un nom est renseigné)',
  'features.rename': 'Renommer la fonctionnalité',
  'features.archive': 'Archiver la fonctionnalité',
  'features.archiveTitle': 'Archiver cette fonctionnalité ?',
  'features.archiveMessage':
    'Cela archivera "{{name}}". Elle ne sera plus visible.',
  'features.unknownType': 'Type de fonctionnalité inconnu : {{type}}',

  'admin.features': 'Fonctionnalités',
  'admin.features.type': 'Type de fonctionnalité',
  'admin.features.allTypes': 'Tous les types',
  'admin.features.restore': 'Restaurer',
  'admin.features.restoreTitle': 'Restaurer cette fonctionnalité ?',
  'admin.features.restoreMessage':
    '"{{name}}" redeviendra visible dans le projet.',
  'admin.features.selectProject':
    'Sélectionnez un projet pour gérer ses fonctionnalités',

  'dashboard.quickAdd.addTask': 'Ajouter une tâche',
  'dashboard.quickAdd.project': 'Projet',
  'dashboard.quickAdd.selectProject': 'Sélectionner un projet...',
  'dashboard.quickAdd.featureInstance': 'Onglet',
  'dashboard.quickAdd.selectInstance': 'Sélectionner un onglet...',
  'dashboard.quickAdd.noInstanceOfType': 'Aucun onglet compatible trouvé.',
  'dashboard.quickAdd.selectFeature': 'Sélectionner un onglet',
  'dashboard.quickAdd.changeFeature': 'Changer',
  'dashboard.quickAdd.taskTitlePlaceholder': 'Titre de la tâche...',
  'dashboard.quickAdd.create': 'Créer',

  'dashboard.quickAddDefaults.menuLabel': 'Valeurs par défaut',
  'dashboard.quickAddDefaults.title': 'Valeurs par défaut de l\'ajout rapide',
  'dashboard.quickAddDefaults.task': 'Tâche',
  'dashboard.quickAddDefaults.event': 'Événement',
  'dashboard.quickAddDefaults.none': 'Aucun (demander à chaque fois)',
  'dashboard.quickAddDefaults.selectTribe': 'Sélectionner une tribu...',
  'dashboard.quickAddDefaults.selectProject': 'Sélectionner un projet...',
  'dashboard.quickAddDefaults.selectInstance': 'Sélectionner un onglet...',
  'dashboard.quickAddDefaults.change': 'Modifier',
  'dashboard.quickAddDefaults.clear': 'Effacer',

  'dashboard.directory.openTasks': 'tâches ouvertes',
  'dashboard.directory.upcomingEvents': 'événements à venir',
  'dashboard.directory.kanbanBoard': 'Tableau Kanban',
  'dashboard.directory.todoList': 'Liste de tâches',
  'dashboard.directory.eventCalendar': 'Calendrier',
  'dashboard.directory.noProjects': 'Aucun projet accessible pour le moment.',
  'dashboard.directory.noTaskInstances': 'Aucun tableau ou liste de tâches accessible pour le moment.',
  'dashboard.directory.noEventInstances': 'Aucun calendrier accessible pour le moment.',
  'dashboard.directory.noFilterMatches': 'Aucun résultat pour les tribus sélectionnées.',

  'dashboard.pinnedTab.pin': 'Épingler comme onglet',
  'dashboard.pinnedTab.unpin': 'Désépingler',
  'dashboard.pinnedTab.unavailable': 'Cette fonctionnalité n\'est plus disponible. Vous pouvez désépingler cet onglet.',
};

export default fr;
